import { SessionState } from '@piwikpro/auth-crate/reducers/session';
import { OrganizationState } from '@piwikpro/organization-crate';
import { IAuthSettingsState } from '@piwikpro/auth-crate/reducers/auth';
import { combineReducers } from 'redux';
import { TrafficMonitorState } from '@piwikpro/traffic-monitor-crate/types';
import { MarketingCratePaymentsState } from '@piwikpro/marketing-crate/redux';
import { UsersState } from '@piwikpro/users-crate/redux';
import apps, { STATE_ROOT as APPS_STATE_ROOT } from './apps';

export {
  configureAppsFetch,
} from './apps';

export const STATE_ROOT = 'administration';

export interface AdministrationState {
  session: SessionState
  organization: OrganizationState
  authSettings: IAuthSettingsState
  trafficMonitor: TrafficMonitorState
  payments: MarketingCratePaymentsState['payments']
  users: UsersState
  administration: {
    [APPS_STATE_ROOT]: ReturnType<typeof apps>
  }
}

export default combineReducers({
  [APPS_STATE_ROOT]: apps,
});
